import { USERS } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  users: [],
  fetchUsersStatus: undefined,
  fetchUsersError: undefined,
  addUserStatus: undefined,
  addUserError: undefined,
  deactivateUserStatus: undefined,
  deactivateUserError: undefined,
  activateUserStatus: undefined,
  activateUserError: undefined,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USERS.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    case USERS.FETCH_USERS:
      return {
        ...state,
        fetchUsersStatus: CONSTANTS.API.STARTED,
      };
    case USERS.FETCH_USERS_SUCCEEDED:
      return {
        ...state,
        users: action.payload,
        fetchUsersStatus: CONSTANTS.API.SUCCEEDED,
      };
    case USERS.FETCH_USERS_FAILED:
      return {
        ...state,
        fetchUsersError: action.payload,
        fetchUsersStatus: CONSTANTS.API.FAILED,
      };
    case USERS.ADD_USER:
      return {
        ...state,
        addUserStatus: CONSTANTS.API.STARTED,
      };
    case USERS.ADD_USER_SUCCEEDED:
      return {
        ...state,
        addUserStatus: CONSTANTS.API.SUCCEEDED,
      };
    case USERS.ADD_USER_FAILED:
      return {
        ...state,
        addUserError: action.payload,
        addUserStatus: CONSTANTS.API.FAILED,
      };
    case USERS.DEACTIVATE_USER:
      return {
        ...state,
        deactivateUserStatus: CONSTANTS.API.STARTED,
      };
    case USERS.DEACTIVATE_USER_SUCCEEDED:
      return {
        ...state,
        deactivateUserStatus: CONSTANTS.API.SUCCEEDED,
      };
    case USERS.DEACTIVATE_USER_FAILED:
      return {
        ...state,
        deactivateUserError: action.payload,
        deactivateUserStatus: CONSTANTS.API.FAILED,
      };
    case USERS.ACTIVATE_USER:
      return {
        ...state,
        activateUserStatus: CONSTANTS.API.STARTED,
      };
    case USERS.ACTIVATE_USER_SUCCEEDED:
      return {
        ...state,
        activateUserStatus: CONSTANTS.API.SUCCEEDED,
      };
    case USERS.ACTIVATE_USER_FAILED:
      return {
        ...state,
        activateUserError: action.payload,
        activateUserStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
